const veganItemIds = new Set([
  'app-2', 'app-16', 'app-17', 'app-18', 'dessert-4',
  'extra-13', 'extra-14', 'extra-15',
]);

const vegetarianItemIds = new Set([
  ...veganItemIds,
  'pizza-1', 'pizza-2', 'pizza-3', 'pizza-5', 'pizza-7', 'pizza-23',
  'salad-1', 'salad-3', 'salad-4', 'salad-5', 'salad-6', 'salad-7',
  'salad-9', 'salad-10', 'salad-11', 'salad-12', 'salad-13', 'salad-14',
  'app-1', 'app-3', 'app-5', 'app-6', 'app-19',
  'ala-2', 'ala-3', 'ala-4',
  'soup-1', 'soup-3',
  'sauce-1', 'sauce-2', 'sauce-3', 'sauce-4',
  'sauce-5', 'sauce-6', 'sauce-7', 'sauce-8',
  'potato-4',
  'bread-1', 'bread-2', 'bread-3', 'bread-4', 'bread-5',
  'pasta-1',
  'dessert-1', 'dessert-2', 'dessert-3', 'dessert-5', 'dessert-6', 'dessert-7',
  'extra-1', 'extra-2', 'extra-3', 'extra-4', 'extra-5', 'extra-16',
]);

const spicyItemIds = new Set([
  'pizza-9', 'pizza-10', 'pizza-11', 'pizza-25', 'pizza-33',
  'app-16', 'sauce-2', 'sauce-6', 'main-1', 'extra-13',
]);

export const getMenuItemTags = (item) => {
  const tags = new Set(item.tags || []);

  if (veganItemIds.has(item.id)) tags.add('vegan');
  if (vegetarianItemIds.has(item.id)) tags.add('vegetarian');
  if (spicyItemIds.has(item.id)) tags.add('spicy');

  return Array.from(tags);
};

export const categorizeMenuData = (menuData) =>
  Object.fromEntries(
    Object.entries(menuData).map(([categoryId, items]) => [
      categoryId,
      items.map((item) => ({ ...item, tags: getMenuItemTags(item) })),
    ])
  );
